import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';

export const getVideoManagementEmbedBaseUrl = () => {
  const fullUrl = getFullUrl(enviro.deployed() ? 'app' : 'local');
  const portalId = PortalIdParser.get();
  return `${fullUrl}/videos-iframe/${portalId}`;
};
